export default "__VITE_ASSET__4jnx2xsI__"